exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.dropdown .menu>.item.current{background:rgba(0,0,0,.05)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-a3dbfc0c!./~/vue-loader/lib/selector.js?type=styles&index=2!./src/components/lib/MultiSelect.vue
 ** module id = 146
 ** module chunks = 0
 **/